"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_Questionnaire_EnableWhen = exports.Questionnaire_EnableWhenOperatorKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_Coding_1 = require("./RTTI_Coding");
var RTTI_Quantity_1 = require("./RTTI_Quantity");
var RTTI_Reference_1 = require("./RTTI_Reference");
var Questionnaire_EnableWhenOperatorKind;
(function (Questionnaire_EnableWhenOperatorKind) {
    Questionnaire_EnableWhenOperatorKind["_exists"] = "exists";
    Questionnaire_EnableWhenOperatorKind["_equal"] = "=";
    Questionnaire_EnableWhenOperatorKind["_notEqual"] = "!=";
    Questionnaire_EnableWhenOperatorKind["_greater"] = ">";
    Questionnaire_EnableWhenOperatorKind["_lower"] = "<";
    Questionnaire_EnableWhenOperatorKind["_greaterOrEqual"] = ">=";
    Questionnaire_EnableWhenOperatorKind["_lowerOrEqual"] = "<=";
})(Questionnaire_EnableWhenOperatorKind = exports.Questionnaire_EnableWhenOperatorKind || (exports.Questionnaire_EnableWhenOperatorKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_Questionnaire_EnableWhen = t.recursion('IQuestionnaire_EnableWhen', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        question: t.string,
        _question: RTTI_Element_1.RTTI_Element,
        operator: (0, EnumType_1.createEnumType)(Questionnaire_EnableWhenOperatorKind, 'Questionnaire_EnableWhenOperatorKind'),
        _operator: RTTI_Element_1.RTTI_Element,
        answerBoolean: t.boolean,
        _answerBoolean: RTTI_Element_1.RTTI_Element,
        answerDecimal: t.number,
        _answerDecimal: RTTI_Element_1.RTTI_Element,
        answerInteger: t.number,
        _answerInteger: RTTI_Element_1.RTTI_Element,
        answerDate: t.string,
        _answerDate: RTTI_Element_1.RTTI_Element,
        answerDateTime: t.string,
        _answerDateTime: RTTI_Element_1.RTTI_Element,
        answerTime: t.string,
        _answerTime: RTTI_Element_1.RTTI_Element,
        answerString: t.string,
        _answerString: RTTI_Element_1.RTTI_Element,
        answerCoding: RTTI_Coding_1.RTTI_Coding,
        answerQuantity: RTTI_Quantity_1.RTTI_Quantity,
        answerReference: RTTI_Reference_1.RTTI_Reference
    });
});
//# sourceMappingURL=RTTI_Questionnaire_EnableWhen.js.map